import React, { useEffect, useState } from 'react';

import closeSvg from '@assets/img/icons/close.svg';
import { makeMuiStyles, useCommonStyles } from '@styles';
import clsx from 'clsx';
import Color from 'color';

const useStyles = makeMuiStyles((theme, common) => ({
  container: {
    ...common.flexColumn,
    justifyContent: 'flex-end',
    position: 'fixed',
    zIndex: 10000,
    top: 0,
    right: 0,
    bottom: 0,
    left: 0,
  },
  backdrop: {
    '$close &': {
      animation: '0.2s ease-in $backdropClose',
    },
    '$open &': {
      animation: '0.2s ease-in $backdropOpen',
    },
    position: 'fixed',
    top: 0,
    right: 0,
    bottom: 0,
    left: 0,
    backgroundColor: Color(theme.palette.common.black).alpha(0.37).toString(),
    zIndex: 1,
  },
  cardContainer: {
    ...common.textBlack,
    ...common.middleText,
    backgroundColor: theme.palette.common.white,
    borderTopLeftRadius: 8,
    borderTopRightRadius: 8,
    zIndex: 2,
    '$open &': {
      animation: '0.2s ease-in $cardOpen',
    },
    '$close &': {
      animation: '0.2s ease-in $cardClose',
      transform: `translateY(100%)`,
    },
  },
  cardBody: {
    padding: '1rem',
    '& a': {
      ...common.link,
    },
  },
  cardTitle: {
    padding: '1rem',
    borderBottom: `1px solid ${theme.palette.grey[300]}`,
  },
  open: {},
  close: {},
  '@keyframes backdropOpen': {
    '0%': {
      opacity: 0,
    },
    '100%': {
      opacity: 1,
    },
  },
  '@keyframes backdropClose': {
    '0%': {
      opacity: 1,
    },
    '100%': {
      opacity: 0,
    },
  },
  '@keyframes cardOpen': {
    '0%': {
      transform: `translateY(100%)`,
    },
    '100%': {
      transform: `translateY(0)`,
    },
  },
  '@keyframes cardClose': {
    '0%': {
      transform: `translateY(0)`,
    },
    '100%': {
      transform: `translateY(100%)`,
    },
  },
}));

export interface MobileBottomPopupProps {
  open?: boolean;
  onClose?: () => void;
  title?: React.ReactNode;
  children?: React.ReactNode;
}

export const MobileBottomPopup: React.FC<MobileBottomPopupProps> = (props) => {
  const { open = true, onClose, title, children } = props;

  const [doOpen, setDoOpen] = useState(open);

  useEffect(() => {
    if (!open) {
      setTimeout(() => setDoOpen(false), 200);
    } else {
      setDoOpen(open);
    }
  }, [open]);

  const classes = {
    ...useCommonStyles(),
    ...useStyles(),
  };

  const renderCard = () => {
    return (
      <div className={classes.cardContainer}>
        <div className={classes.cardTitle} onClick={onClose}>
          {title}
          <img
            src={closeSvg}
            alt="Close"
            style={{ float: 'right', position: 'relative', top: 5 }}
          />
        </div>
        <div className={classes.cardBody}>{children}</div>
      </div>
    );
  };

  if (!doOpen) return null;

  return (
    <div className={clsx(classes.container, open ? classes.open : classes.close)}>
      <div className={clsx(classes.backdrop)} onClick={onClose} />

      {renderCard()}
    </div>
  );
};
